import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { DebtStateResponse } from "../../models/debt-states.model";
import { DebtYearResponse } from "../../models/debt-year.model";

export namespace DebtActions {
    @logDispatcher
    export class GetDebtStates {
      static readonly type = '[DebtStatus] GetDebtStates';
      constructor() {}
    }
  
    @logDispatcher
    export class GetDebtStatesSuccess {
      static readonly type = '[DebtStatus] GetDebtStatesSuccess';
      constructor(public debtStates: DebtStateResponse[]) {}
    }
  
    @logDispatcher
    export class GetDebtYears {
      static readonly type = '[DebtStatus] GetDebtYears';
      constructor() {}
    }
  
    @logDispatcher
    export class GetDebtYearsSuccess {
      static readonly type = '[DebtStatus] GetDebtYearsSuccess';
      constructor(public debtYears: DebtYearResponse[]) {}
    }
  
    @logDispatcher
    export class Error {
      static readonly type = '[DebtStatus] Error';
      constructor(public error: any) {}
    }
}